module.exports = __webpack_public_path__ + "static/img/LOGOBAMBO.161f30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LOGOBAMBO.png
// module id = zs9K
// module chunks = 4